import React from "react";
import { faqs } from "../data";
import SectionHead from "./SectionHead";

const Faqs = () => (
  <section className="faq-section" id="faq" aria-labelledby="faq-heading">
    <div className="container">
      <SectionHead
        headingId="faq-heading"
        title={
          <>
            Questions, <em>answered</em>.
          </>
        }
        body="The things people usually ask before getting in touch."
      />
      <div className="faq-list">
        {faqs.map((faq) => (
          <details key={faq.question} className="faq-item">
            <summary>{faq.question}</summary>
            <div
              className="faq-answer"
              dangerouslySetInnerHTML={{ __html: faq.answerHtml }}
            />
          </details>
        ))}
      </div>
    </div>
  </section>
);

export default Faqs;
